"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const getToken_1 = __importDefault(require("./getToken"));
const zenithApiPrivate = axios_1.default.create({});
zenithApiPrivate.interceptors.request.use((config) => {
    const token = (0, getToken_1.default)();
    if (token && config.headers) {
        // eslint-disable-next-line dot-notation
        config.headers.authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));
zenithApiPrivate.interceptors.response.use((response) => response, (error) => {
    var _a;
    if ([401, 403].includes((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status)) {
        window.location.replace('/login');
    }
    return Promise.reject(error);
});
exports.default = zenithApiPrivate;
